export default __webpack_public_path__ + "static/colibri05-3240700b4202bd8f4083b9c0497dc190.pdf";